/* eslint-disable no-restricted-syntax */

import cloneDeep from 'lodash.clonedeep';

/**
 * Returns items which properties `by` contain searched `term`
 * @todo Should handle diacritics?
 */
export const filterBySearchTerm = <T, K extends keyof T>(term: string, list: T[], ...by: K[]) => {
  if (!term) {
    return list;
  }

  const searchedTerm = term.trim().toLowerCase();

  return list.filter((item) => {
    for (const key of by) {
      // TODO: fix undefined is transformed to string
      if (String(item[key]).toLowerCase().includes(searchedTerm)) {
        return true;
      }
    }

    return false;
  });
};

/**
 * Creates a record object keyed with `by` objects' property
 */
export const recordBy = <T, K extends keyof T>(list: T[], by: K) => {
  const result = {} as Record<string, T>;
  if (list == null || !list.length || by == null) {
    // null safe
    return result;
  }

  for (const item of list) {
    result[String(item[by])] = item;
  }

  return result;
};

export const recordFromIds = <T>(ids: string[], defaultValue: T) => {
  const result = {} as Record<string, T>;
  if (ids == null || !ids.length || defaultValue == null) {
    // null safe
    return result;
  }

  const isObject = typeof defaultValue === 'object';

  for (const id of ids) {
    result[id] = isObject ? cloneDeep(defaultValue) : defaultValue;
  }

  return result;
};
